import { render, staticRenderFns } from "./IconCalendar.vue?vue&type=template&id=6cc6932d"
import script from "./IconCalendar.vue?vue&type=script&setup=true&lang=ts"
export * from "./IconCalendar.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports